import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
const META_PIXEL_ID = '1744921309871699';
(function installMetaPixel() {
  if (typeof window === 'undefined') return;
  const w: any = window;
  if (w.fbq) return; // already installed
  const n: any = function () {
    n.callMethod ? n.callMethod.apply(n, arguments as any) : n.queue.push(arguments);
  };
  w.fbq = n;
  if (!w._fbq) w._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
  if (typeof document !== 'undefined') {
    const t = document.createElement('script');
    t.async = true;
    t.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const s = document.getElementsByTagName('script')[0];
    if (s && s.parentNode) {
      s.parentNode.insertBefore(t, s);
    } else {
      ;
      (document.head || document.body || document.documentElement).appendChild(t);
    }
  }
  w.fbq('init', META_PIXEL_ID);
  w.fbq('track', 'PageView');
})();
(function injectPerformanceHints() {
  if (typeof document === 'undefined') return;
  const head = document.head;
  if (!head) return;
  const hints: Array<{
    rel: string;
    href: string;
    crossOrigin?: string;
    as?: string;
    type?: string;
  }> = [{
    rel: 'preconnect',
    href: 'https://fonts.googleapis.com'
  }, {
    rel: 'preconnect',
    href: 'https://fonts.gstatic.com',
    crossOrigin: 'anonymous'
  }, {
    rel: 'preconnect',
    href: 'https://cdn.magicpatterns.com',
    crossOrigin: 'anonymous'
  },
  // Pixel domains — promote dns-prefetch to preconnect for faster event delivery
  {
    rel: 'preconnect',
    href: 'https://connect.facebook.net'
  }, {
    rel: 'preconnect',
    href: 'https://www.facebook.com'
  }, {
    rel: 'dns-prefetch',
    href: 'https://ebookpromax.online'
  }];
  hints.forEach(h => {
    if (document.querySelector(`link[rel="${h.rel}"][href="${h.href}"]`)) return;
    const link = document.createElement('link');
    link.rel = h.rel;
    link.href = h.href;
    if (h.crossOrigin) link.crossOrigin = h.crossOrigin;
    if (h.as) (link as any).as = h.as;
    if (h.type) link.type = h.type;
    head.appendChild(link);
  });
  // Preload the hero image (LCP element)
  const heroImageUrl = 'https://cdn.magicpatterns.com/uploads/fcUBNp67MDXVcAKoedr6Rg/FOTO_PRINCIPAL_CUENTOS_INFANTILES.png';
  if (!document.querySelector(`link[rel="preload"][href="${heroImageUrl}"]`)) {
    const preloadImg = document.createElement('link');
    preloadImg.rel = 'preload';
    preloadImg.as = 'image';
    preloadImg.href = heroImageUrl;
    (preloadImg as any).fetchPriority = 'high';
    head.appendChild(preloadImg);
  }
  // Async load Google Fonts
  const fontsHref = 'https://fonts.googleapis.com/css2?family=Fraunces:ital,opsz,wght@0,9..144,100..900;1,9..144,100..900&family=Nunito:ital,wght@0,200..1000;1,200..1000&display=swap';
  if (!document.querySelector(`link[data-async-fonts="true"]`)) {
    const fontPreload = document.createElement('link');
    fontPreload.rel = 'preload';
    (fontPreload as any).as = 'style';
    fontPreload.href = fontsHref;
    fontPreload.setAttribute('data-async-fonts', 'true');
    fontPreload.onload = function () {
      ;
      (fontPreload as HTMLLinkElement).onload = null;
      (fontPreload as HTMLLinkElement).rel = 'stylesheet';
    };
    head.appendChild(fontPreload);
    const noscript = document.createElement('noscript');
    const fallback = document.createElement('link');
    fallback.rel = 'stylesheet';
    fallback.href = fontsHref;
    noscript.appendChild(fallback);
    head.appendChild(noscript);
  }
})();
render(<App data-id="element-235" />, document.getElementById('root'));